import { createContext } from 'react';

import { PdfData } from '../types';
import { BasePdfOptions } from '@breathelife/types';

export type PdfContextProps<T> = PdfData & T;

export const PdfContext = createContext<PdfContextProps<BasePdfOptions>>({} as PdfContextProps<BasePdfOptions>);
